module.exports = __webpack_public_path__ + "static/img/AirTax-logo-h5.e3af5b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AirTax-logo-h5.png
// module id = CZB2
// module chunks = 34